import React, { useState } from 'react';
import { CloseableModal } from '../../../../components/CloseableModal';
import { AlertObject, AlertType } from '../../../../components/Alert';
import { EmailModalBody } from './EmailModalBody';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { Email } from '../../../../entities/Email';
import { ConnectEmailIntegrationModal } from './ConnectEmailIntegrationModal';
import { appendQueryParam } from '../../../../utils/url';

interface PropTypes {
  applicationIds: number[];
  authorizeUrl: string;
  hasEmailConnected?: boolean;
  isOpen: boolean;
  toEmails: string[];
  description?: string;
  replyToEmail?: Email;
  onClose: (succeeded?: boolean) => void;
  setAlert?: (data: AlertObject) => void;
}

interface InnerModalPropTypes extends PropTypes {
  handleClose: (succeeded?: boolean) => void;
  setIsLoading: (loading: boolean) => void;
}

function getConnectionEmailUrl(authorizeUrl: string) {
  return appendQueryParam(authorizeUrl, 'state', window.location.href);
}

function EmailModal(props: InnerModalPropTypes) {
  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={props.onClose}
      isOpen={props.isOpen}
      style={{ width: 'auto' }}
      size={'lg'}
      modalHeaderTag='div'
      headerClassName='p-4 bg-gray'
      contentClassName='rounded-5'
      bodyClassName='p-4'
      closeButtonClassName='me-0'
      closeDisabled={false}
      keyboard={true}
      backdrop={true}
      headerChildren={<h3 className='m-0 fs-4'>Send email</h3>}
      bodyChildren={
        props.hasEmailConnected ? (
          <>
            {props.description && (
              <div className='fs-5 mb-3'>{props.description}</div>
            )}
            <EmailModalBody
              applicationIds={props.applicationIds}
              toEmails={props.toEmails}
              replyToEmail={props.replyToEmail}
              onClose={props.handleClose}
            />
          </>
        ) : (
          <ConnectEmailIntegrationModal
            onClose={props.handleClose}
            url={getConnectionEmailUrl(props.authorizeUrl)}
          />
        )
      }
    />
  );
}

function handleClose(
  succeeded: boolean,
  onClose: (state: boolean) => void,
  setAlert: (alert: AlertObject) => void,
) {
  let alertObject: AlertObject;

  if (setAlert) {
    if (succeeded) {
      alertObject = {
        message: 'This email was successfully sent.',
        type: AlertType.Success,
      };
    } else if (succeeded === false) {
      alertObject = {
        message: 'The email was not sent.',
        type: AlertType.Danger,
      };
    }

    setAlert(alertObject);
  }

  onClose(succeeded);
}

export function SendEmailModal(props: PropTypes) {
  if (!props.isOpen) {
    return null;
  }

  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <EmailModal
        setIsLoading={setIsLoading}
        {...props}
        handleClose={(succeded: boolean) =>
          handleClose(succeded, props.onClose, props.setAlert)
        }
      />
    </>
  );
}
